<div class="d-flex flex-row">
  <div>
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column w-100">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    <!-- !!Loading animation -->
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <div class="w-100 d-flex flex-column justify-content-start">
          <div style="max-width: fit-content;">
            <h3>Importar ficheiro</h3>
            <div style=" display: flex; align-items: center; gap: 10px;">
              <input #fileInput type="file" accept=".csv" (change)="onFileSelected($event)"
                class="form-control upload-input" />
                <button class="btn-processar" (click)="importar()" [disabled]="loading">
                  <span>Importar</span>
                </button>
              </div>
            </div>
            <h3 style="margin-bottom: 0;" class="mt-4">Preferências dos clientes</h3>
            <div class="search-container mt-3" style="display: flex; align-items: center; gap: 10px;">
              <input type="text" [(ngModel)]="searchTerm" placeholder="Procurar por número de cliente"
                class="form-control" style="max-width: 300px;" (keyup.enter)="onSearch()" />
                <button class="btn-processar" (click)="onSearch()" [disabled]="loading">
                  <span>Pesquisar</span>
                </button>
              </div>
              <div class="w-100 d-flex flex-column justify-content-start">
                <table mat-table [dataSource]="clientsPreferences" class="w-100 mt-2"
                  style="border-radius: 10px 10px 0 0 !important;">
                  <ng-container matColumnDef="numero">
                    <th mat-header-cell *matHeaderCellDef style="min-width: 185px;"> Número de cliente</th>
                    <td mat-cell *matCellDef="let cliente"> {{ cliente.n_Cliente}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef> Nome do cliente</th>
                    <td mat-cell *matCellDef="let cliente"> {{ cliente.clientName }} </td>
                  </ng-container>
                  <ng-container matColumnDef="decisao">
                    <th mat-header-cell *matHeaderCellDef> Decisão </th>
                    <td mat-cell *matCellDef="let cliente">
                      {{ cliente.decision === true ? 'Aceitou' : cliente.decision === false ? 'Recusou' :
                      '—' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dataHora">
                    <th mat-header-cell *matHeaderCellDef style="min-width: 170px;"> Data e hora da decisão
                    </th>
                    <td mat-cell *matCellDef="let cliente">
                      Data: {{ cliente.decisionDateTime | date:'dd/MM/yyyy' }}<br>
                      Hora: {{ cliente.decisionDateTime | date:'HH:mm' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="bloqueados">
                    <th mat-header-cell *matHeaderCellDef> Laboratórios bloqueados </th>
                    <td mat-cell *matCellDef="let cliente">
                      {{ cliente.labsName.join(', ') }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="actions-row">
                  <button class="btn-processar" (click)="exportAllPreferencesCSV()" [disabled]="loading">
                    <span>Exportar preferências</span>
                  </button>
                  <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                    [pageSizeOptions]="[10, 20, 50]" (page)="onPageChange($event)" class="paginator">
                  </mat-paginator>
                </div>
              </div>
            </div>
          </div>
        }
        <app-footer></app-footer>
      </div>
    </div>